import DomPurify from 'dompurify';
import { type FC, useMemo } from 'react';
import { useLocation } from 'wouter';

import { staticPageRequest } from 'api/cms';
import Meta from 'components/Meta';
import { useLanguage } from 'store';
import useRequest from 'utils/useRequest';

import styles from './SeoText.module.scss';
import { ALLOWED_TAGS, FORBID_ATTR } from './constants';

const SeoText: FC = () => {
  const [slug] = useLocation();
  const [
    {
      current: { code: lang },
    },
  ] = useLanguage();

  const { data } = useRequest(
    () =>
      staticPageRequest({
        query: {
          lang,
          name: slug,
        },
      }),
    [slug, lang],
  );

  const content: string | undefined = useMemo(
    () =>
      data?.data
        ? DomPurify.sanitize(data.data, {
            ALLOWED_TAGS,
            FORBID_ATTR,
          })
        : undefined,
    [data],
  );

  return (
    <>
      <Meta
        title={data?.meta_title}
        metaDescription={data?.meta_description}
        metaKeywords={data?.meta_keywords}
        ogTitle={data?.og_title}
        ogDescription={data?.og_description}
      />
      {content && (
        <article
          className={styles.wrapper}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized HTML from CMS
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
};

export default SeoText;
